
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class PDQuotationAdditionalChargesGrid extends Serenity.EntityGrid<PDQuotationAdditionalChargesRow, any> {
        protected getColumnsKey() { return 'ProductDevelopment.PDQuotationAdditionalCharges'; }
        //protected getDialogType() { return PDQuotationAdditionalChargesDialog; }
        protected getIdProperty() { return PDQuotationAdditionalChargesRow.idProperty; }
        protected getInsertPermission() { return PDQuotationAdditionalChargesRow.insertPermission; }
        protected getLocalTextPrefix() { return PDQuotationAdditionalChargesRow.localTextPrefix; }
        protected getService() { return PDQuotationAdditionalChargesService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}